import BackendClient from '../backend-client';
import Bopsid, { modelFactory } from './model';

export default class BopsidClient extends BackendClient {
  constructor(options = {}) {
    super(modelFactory, options);
  }

  get = async () => {
    const response = await this.request('post')({
      headers: {
        'X-Obj-Attrs': 'bopsid_val',
      },
    });
    return this.format(response);
  }
}

export {
  Bopsid,
};
